/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Summary_LabelInputs */

const en_us2_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary after a workout`)
};

const pt_br2_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo depois do treino`)
};

const es_419_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen después del entrenamiento`)
};

const pt_pt2_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo depois do treino`)
};

const fr_fr2_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé après la séance`)
};

const de_de2_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung nach dem Training`)
};

const it_it2_profile_summary_label = /** @type {(inputs: Profile_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo dopo l'allenamento`)
};

/**
* | output |
* | --- |
* | "Summary after a workout" |
*
* @param {Profile_Summary_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_summary_label = /** @type {((inputs?: Profile_Summary_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Summary_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_summary_label(inputs)
	if (locale === "es-419") return es_419_profile_summary_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_summary_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_summary_label(inputs)
	if (locale === "de-DE") return de_de2_profile_summary_label(inputs)
	if (locale === "it-IT") return it_it2_profile_summary_label(inputs)
	return en_us2_profile_summary_label(inputs)
});
export { profile_summary_label as "profile.summary_label" }